import {Plan} from 'ApplicationEntry/models/ProductsRiders/PlanModel';
import {SalaryDeductionOccupationClassModel} from 'ApplicationEntry/models/ProductsRiders/SalaryDeductionOccupationClassModel';
import * as G from 'ApplicationEntry/models/ProductsRiders/Shop/GroupShop';
import * as NY from 'ApplicationEntry/models/ProductsRiders/Shop/NewYorkShop';
import * as O from 'ApplicationEntry/models/ProductsRiders/Shop/OrdinaryShop';
import {matchShopByType, Shop} from 'ApplicationEntry/models/ProductsRiders/Shop/Shop';
import {Async, Loading} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

export enum ShopActionType {
  CHANGE_PLAN_TYPE = 'shop/CHANGE_PLAN_TYPE',
  CHANGE_PREMIUM = 'shop/CHANGE_PREMIUM',
  CHANGE_CALCULATED_PREMIUM = 'shop/CHANGE_CALCULATED_PREMIUM',
  CHANGE_CWA = 'shop/CHANGE_CWA',
  CHANGE_BASE_UNITS = 'shop/CHANGE_BASE_UNITS',
  CHANGE_SECTION125 = 'shop/CHANGE_SECTION125',
  CHANGE_SELECT_CGI = 'shop/CHANGE_SELECT_CGI',
  CHANGE_RIDER_CODES = 'shop/CHANGE_RIDER_CODES',
  CHANGE_RIDER_AMT = 'shop/CHANGE_RIDER_AMT',
  CHANGE_PACKAGE = 'shop/CHANGE_PACKAGE',
  CHANGE_SITUS = 'shop/CHANGE_SITUS',
  CHANGE_REPLACEMENT = 'shop/CHANGE_REPLACEMENT',
  CHANGE_POLICY_NUMBER = 'shop/CHANGE_POLICY_NUMBER',
  CHANGE_RIDER_COVERAGE = 'shop/CHANGE_RIDER_COVERAGE',
  CHANGE_RIDER_PREMIUM = 'shop/CHANGE_RIDER_PREMIUM',
  CHANGE_JSTAMP = 'shop/CHANGE_JSTAMP',
  GET_PACKAGE_LIST = 'shop/GET_PACKAGE_LIST',
  CHANGE_PACKAGE_LIST = 'shop/CHANGE_PACKAGE_LIST',
  CHANGE_PLAN = 'shop/CHANGE_PLAN',
  CHANGE_RIDER_INFORMATION = 'shop/CHANGE_RIDER_INFORMATION',
  CHANGE_RIDER_CODE_LIST = 'shop/CHANGE_RIDER_CODE_LIST',
  CLEAR_SHOP = 'shop/CLEAR_SHOP',
  CHANGE_OCC_CLASS = 'shop/CHANGE_OCC_CLASS',
  GET_OCC_CLASS = 'shop/GET_OCC_CLASS',
  CHANGE_PACKAGE_ITEM = 'shop/CHANGE_PACKAGE_ITEM',
  GET_GROUP_SHOP_PRODUCTS = 'shop/GET_GROUP_SHOP_PRODUCTS',
}

export const isShopAction = (action: any): action is ShopAction => action.type in reverseEnum(ShopActionType);

export const changePlanType = (planType: string) => createAction(ShopActionType.CHANGE_PLAN_TYPE, {planType});
export const changePremium = (premium: string) => createAction(ShopActionType.CHANGE_PREMIUM, {premium});
export const changeCalculatedPremium = (calculatedPremium: string) =>
  createAction(ShopActionType.CHANGE_CALCULATED_PREMIUM, {calculatedPremium});
export const changeCWA = (cwa: string) => createAction(ShopActionType.CHANGE_CWA, {cwa});
export const changeBaseUnit = (baseUnit: number) => createAction(ShopActionType.CHANGE_BASE_UNITS, {baseUnit});
export const changeSection125 = (section125: boolean) => createAction(ShopActionType.CHANGE_SECTION125, {section125});
export const changeSelectCGI = (selectCGI: boolean) => createAction(ShopActionType.CHANGE_SELECT_CGI, {selectCGI});
export const changeRiderCodes = (riderCode: string, index: number) =>
  createAction(ShopActionType.CHANGE_RIDER_CODES, {riderCode, index});
export const changePackageItem = (packageItem: object) =>
  createAction(ShopActionType.CHANGE_PACKAGE_ITEM, {packageItem});
export const changeRiderAmt = (riderAmt: number, index: number) =>
  createAction(ShopActionType.CHANGE_RIDER_AMT, {riderAmt, index});
export const changePackage = (packageOpt: string) => createAction(ShopActionType.CHANGE_PACKAGE, {packageOpt});
export const changeSitus = (situs: string) => createAction(ShopActionType.CHANGE_SITUS, {situs});
export const changeReplacement = (replacement: boolean) =>
  createAction(ShopActionType.CHANGE_REPLACEMENT, {replacement});
export const changePolicyNumber = (policyNumber: string) =>
  createAction(ShopActionType.CHANGE_POLICY_NUMBER, {policyNumber});
export const changeRiderCoverage = (coverage: boolean) =>
  createAction(ShopActionType.CHANGE_RIDER_COVERAGE, {coverage});
export const changeRiderPremium = (premium: boolean) => createAction(ShopActionType.CHANGE_RIDER_PREMIUM, {premium});
export const changeJStamp = (stamp: boolean) => createAction(ShopActionType.CHANGE_JSTAMP, {stamp});
export const getPackages = (planCode: string, caseNumber: string) =>
  createAction(ShopActionType.GET_PACKAGE_LIST, {planCode, caseNumber});
export const changePackageList = (packages: Async<object[]>) =>
  createAction(ShopActionType.CHANGE_PACKAGE_LIST, {packages});
export const changePlan = (plan: string) => createAction(ShopActionType.CHANGE_PLAN, {plan});
export const changeRiderInformation = (amount: number, code: string, index: number) =>
  createAction(ShopActionType.CHANGE_RIDER_INFORMATION, {amount, code, index});
export const changeRiderCodeList = (plan: string) => createAction(ShopActionType.CHANGE_RIDER_CODE_LIST, {plan});
export const clearShop = () => createAction(ShopActionType.CLEAR_SHOP);
export const changeOccClass = (occClass: SalaryDeductionOccupationClassModel) =>
  createAction(ShopActionType.CHANGE_OCC_CLASS, {occClass});
export const getOccClass = (caseNumber: string, plan: Plan) =>
  createAction(ShopActionType.GET_OCC_CLASS, {caseNumber, plan});

export const getGroupShopProducts = (caseNumber: string, planCode: string) =>
  createAction(ShopActionType.GET_GROUP_SHOP_PRODUCTS, {caseNumber, planCode});

export type ShopAction =
  | ReturnType<typeof changePlanType>
  | ReturnType<typeof changePremium>
  | ReturnType<typeof changeCalculatedPremium>
  | ReturnType<typeof changeCWA>
  | ReturnType<typeof changeBaseUnit>
  | ReturnType<typeof changeSelectCGI>
  | ReturnType<typeof changeSection125>
  | ReturnType<typeof changeRiderCodes>
  | ReturnType<typeof changeRiderAmt>
  | ReturnType<typeof changePackage>
  | ReturnType<typeof changeSitus>
  | ReturnType<typeof changeReplacement>
  | ReturnType<typeof changePolicyNumber>
  | ReturnType<typeof changeRiderCoverage>
  | ReturnType<typeof changeRiderPremium>
  | ReturnType<typeof changeJStamp>
  | ReturnType<typeof getPackages>
  | ReturnType<typeof changePackageList>
  | ReturnType<typeof changePlan>
  | ReturnType<typeof changeRiderInformation>
  | ReturnType<typeof changeRiderCodeList>
  | ReturnType<typeof clearShop>
  | ReturnType<typeof changeOccClass>
  | ReturnType<typeof getOccClass>
  | ReturnType<typeof changePackageItem>
  | ReturnType<typeof getGroupShopProducts>;

type ShopState = Shop;

export default (state: ShopState, action: ShopAction): ShopState => {
  switch (action.type) {
    case ShopActionType.CHANGE_PLAN_TYPE:
      return matchShopByType<Shop>({
        Ordinary: O.changePlanType(action.payload.planType),
        Group: G.changePlanType(action.payload.planType),
        NewYork: NY.changePlanType(action.payload.planType),
      })(state);
    case ShopActionType.CHANGE_PREMIUM:
      return matchShopByType<Shop>({
        Ordinary: O.changePremium(action.payload.premium),
        Group: G.changePremium(action.payload.premium),
        NewYork: NY.changePremium(action.payload.premium),
      })(state);
    case ShopActionType.CHANGE_CALCULATED_PREMIUM:
      return matchShopByType<Shop>({
        Ordinary: O.changeCalculatedPremium(action.payload.calculatedPremium),
        Group: G.changeCalculatedPremium(action.payload.calculatedPremium),
        NewYork: NY.changeCalculatedPremium(action.payload.calculatedPremium),
      })(state);
    case ShopActionType.CHANGE_CWA:
      return matchShopByType<Shop>({
        Ordinary: O.changeCWA(action.payload.cwa),
        Group: G.changeCWA(action.payload.cwa),
        NewYork: NY.changeCWA(action.payload.cwa),
      })(state);
    case ShopActionType.CHANGE_BASE_UNITS:
      return matchShopByType<Shop>({
        Ordinary: O.changeBaseUnit(action.payload.baseUnit),
        Group: () => state,
        NewYork: NY.changeBaseUnit(action.payload.baseUnit),
      })(state);
    case ShopActionType.CHANGE_SELECT_CGI:
      return matchShopByType<Shop>({
        Ordinary: O.changeCGI(action.payload.selectCGI),
        Group: () => state,
        NewYork: NY.changeCGI(action.payload.selectCGI),
      })(state);
    case ShopActionType.CHANGE_SECTION125:
      return matchShopByType<Shop>({
        Ordinary: O.changeSection(action.payload.section125),
        Group: G.changeSection(action.payload.section125),
        NewYork: NY.changeSection(action.payload.section125),
      })(state);
    case ShopActionType.CHANGE_RIDER_CODES:
      return matchShopByType<Shop>({
        Group: () => state,
        NewYork: NY.changeRiderCodes(action.payload.riderCode, action.payload.index),
        _: () => state,
      })(state);
    case ShopActionType.CHANGE_PACKAGE_ITEM:
      return matchShopByType<Shop>({
        Ordinary: () => state,
        Group: G.changePackageItem(action.payload.packageItem),
        NewYork: () => state,
      })(state);
    case ShopActionType.CHANGE_RIDER_AMT:
      return matchShopByType<Shop>({
        Group: G.changeRiderAmount(action.payload.riderAmt, action.payload.index),
        NewYork: NY.changeRiderAmount(action.payload.riderAmt, action.payload.index),
        _: () => state,
      })(state);
    case ShopActionType.CHANGE_PACKAGE:
      return matchShopByType<Shop>({
        Ordinary: () => state,
        Group: G.changePackage(action.payload.packageOpt),
        NewYork: () => state,
      })(state);
    case ShopActionType.CHANGE_SITUS:
      return matchShopByType<Shop>({
        Ordinary: () => state,
        Group: G.changeSitus(action.payload.situs),
        NewYork: () => state,
      })(state);
    case ShopActionType.CHANGE_REPLACEMENT:
      return matchShopByType<Shop>({
        Ordinary: () => state,
        Group: G.changeReplacement(action.payload.replacement),
        NewYork: () => state,
      })(state);
    case ShopActionType.CHANGE_POLICY_NUMBER:
      return matchShopByType<Shop>({
        Ordinary: () => state,
        Group: G.changePolicyNumber(action.payload.policyNumber),
        NewYork: () => state,
      })(state);
    case ShopActionType.CHANGE_RIDER_COVERAGE:
      return matchShopByType<Shop>({
        Ordinary: () => state,
        Group: G.changeRiderCoverage(action.payload.coverage),
        NewYork: () => state,
      })(state);
    case ShopActionType.CHANGE_RIDER_PREMIUM:
      return matchShopByType<Shop>({
        Ordinary: () => state,
        Group: G.changeRiderPremium(action.payload.premium),
        NewYork: () => state,
      })(state);
    case ShopActionType.CHANGE_JSTAMP:
      return matchShopByType<Shop>({
        Ordinary: () => state,
        Group: G.changeJStamp(action.payload.stamp),
        NewYork: () => state,
      })(state);
    case ShopActionType.GET_PACKAGE_LIST:
      return matchShopByType<Shop>({
        Group: G.changePackageList(new Loading()),
        _: () => state,
      })(state);
    case ShopActionType.CHANGE_PACKAGE_LIST:
      return matchShopByType<Shop>({
        Group: G.changePackageList(action.payload.packages),
        _: () => state,
      })(state);
    case ShopActionType.CHANGE_PLAN:
      return matchShopByType<Shop>({
        Group: G.changePlan(action.payload.plan),
        _: () => state,
      })(state);
    case ShopActionType.CHANGE_RIDER_INFORMATION:
      return matchShopByType<Shop>({
        Ordinary: O.changeRiderInformation(action.payload.amount, action.payload.code, action.payload.index),
        Group: G.changeRiderInformation(action.payload.amount, action.payload.code, action.payload.index),
        _: () => state,
      })(state);
    case ShopActionType.CHANGE_OCC_CLASS:
      return matchShopByType<Shop>({
        Group: G.changeOccClass(action.payload.occClass),
        _: () => state,
      })(state);
    case ShopActionType.GET_GROUP_SHOP_PRODUCTS:
      return matchShopByType<Shop>({
        Group: G.changePackageList(new Loading()),
        _: () => state,
      })(state);
    case ShopActionType.GET_OCC_CLASS:
      return matchShopByType<Shop>({
        Group: G.changeOccClass(new Loading()),
        _: () => state,
      })(state);
    case ShopActionType.CHANGE_RIDER_CODE_LIST:
      return matchShopByType<Shop>({
        Group: G.changeRiderCodes(action.payload.plan),
        _: () => state,
      })(state);
    case ShopActionType.CLEAR_SHOP:
      if (state.key === 'InvalidGroupShop' || state.key === 'ValidGroupShop') {
        return G.EmptyGroupShop;
      } else if (state.key === 'InvalidNewYorkShop' || state.key === 'ValidNewYorkShop') {
        return NY.EmptyNewYorkShop;
      } else if (state.key === 'InvalidOrdShop' || state.key === 'ValidOrdShop') {
        return O.EmptyOrdShop;
      }

      return state;
    default:
      return state;
  }
};
